module.exports = __webpack_public_path__ + "img/mupgradeMember.a0f73a79.png";